'use strict';

var _ = require('underscore'),
  CarouselBaseView = require('./CarouselBaseView'),
  utilities = require('../../js/utilities'),
  PromotedSliderView;

PromotedSliderView = CarouselBaseView.extend({
  options: {
    slideClass: '.PromotedSlider-slide',
    pagination: false,
    arrows: true,
    speed: 600,
    delay: 5000,
    mobileFirst: true,
    autoplay: false
  },

  initialize: function(options) {
    if (utilities._isMobileOrTabletDevice()) {
      options.autoplay = false;
      if (PromotedSliderView.__super__.options) {
        PromotedSliderView.__super__.options.autoplay = false;
      }
      if (this.options) {
        this.options.autoplay = false;
      }
    }
    this.options = _.defaults(this.options, PromotedSliderView.__super__.options);
    PromotedSliderView.__super__.initialize.call(this, options);
  }
}, {
  create: function($parent) {
    $parent.find('.PromotedSlider-slider').each(function(n, el) {
      new PromotedSliderView({
        el: el
      });
    });
  }
});

module.exports = PromotedSliderView;



// WEBPACK FOOTER //
// ./assets/components/Carousel/PromotedSlider.js